import { Roles } from '../constants';

export class CommentService {
    public isSuez(commentRole: any) {
        return commentRole.includes(Roles.ROLE_SUEZ);
    }

}

export default new CommentService();